/**
 * Дешифратор VIN-кодов УАЗ 
 * 
 * МЕТОДЫ
 * - getCarModel: модификация транспортных средств (модель)
 * - getCarYear: год выпуска
 * - getCarManufactorer: производитель
 * 
 * @param       {String}    vin     VIN-код автомобиля
 * @returns     {Object}    Значения свойств объекта - языковые константы для локализованного вывода
 */

export default function vinDecode(vin) {

    let vinInfo = {
        model:          null, 
        name:           'unknown', 
        type:           'unknown', 
        modification:   [], 
        year:           null, 
        manufactorer:   null, 
        image:          '/src/assets/images/models/patriot_lg.jpg', 
    }

    // Проверка на тип и длину
    if (typeof vin !== 'string' || vin.length !== 17) return vinInfo

    // WMI-код: международный идентификатор автопроизводителя
    switch(vin.slice(0, 3)) {
        case 'XTT': 
            vinInfo.owner = 'ООО "УАЗ"'
            break
        case 'XU6': 
            vinInfo.owner = 'ООО "Автодом"'
            break
    }

    function getCarModel(index) {

        let model           = '',
            name            = '', 
            type            = '', 
            modification    = [], 
            image           = ''

        switch(index) {

            case '316300':      // Патриот обычный
                model           = 'Патриот'
                name            = 'patriot'
                type            = '3163'
                modification    = []
                image           = '/src/assets/images/models/patriot/patriot_lg.jpg'
                break
            case '330365':      // Бортовой однорядный
                model           = 'СГР'
                name            = 'sgr'
                type            = '330365'
                modification    = []
                image           = '/src/assets/images/models/sgr/330365.jpg'
                break
            case '374195':      // Грузовой фургон
                model           = 'СГР'
                name            = 'sgr'
                type            = '3741'
                modification    = '374195'
                image           = '/src/assets/images/models/sgr/374195.jpg'
                break
            case '390995':      // Комби
                model           = 'СГР'
                name            = 'sgr'
                type            = '390995'
                modification    = []
                image           = '/src/assets/images/models/sgr/390995.jpg'
                break
            case '390945':      // Бортовой двухрядный
                model           = 'СГР'
                name            = 'sgr'
                type            = '390945'
                modification    = []
                image           = '/src/assets/images/models/sgr/390945.jpg'
                break
            case '220695':      // Пассажирский / автобус
                model           = 'СГР'
                name            = 'sgr'
                type            = '220695'
                modification    = []
                image           = '/src/assets/images/models/sgr/220695.jpg'
                break
            case '396221':      // Автозак [НЕТ ФОТО]
                model           = 'СГР'
                name            = 'sgr'
                type            = '220695' 
                modification    = []
                break
            case '396222':      // Полиция [НЕТ ФОТО]
                model           = 'СГР'
                name            = 'sgr'
                type            = '220695'
                modification    = []
                image           = '/src/assets/images/models/sgr/220695.jpg'
                break
            case '396223':      // Скорая [НЕТ ФОТО]
                model           = 'СГР'
                name            = 'sgr'
                type            = '220695'
                modification    = []
                image           = '/src/assets/images/models/sgr/220695.jpg'
                break
            case '396295':      // Санитарка [НЕТ ФОТО]
                model           = 'СГР'
                name            = 'sgr'
                type            = '220695'
                modification    = []
                image           = '/src/assets/images/models/sgr/220695.jpg'
                break
            case '184600':      // Пикап специальный (кинологи, обеспечение) [НЕТ ФОТО]
                model           = 'Пикап'
                name            = 'pickup'
                type            = '2363'
                modification    = []
                image           = '/src/assets/images/models/pickup/pickup.jpg'
                break
            case '236320':      // Пикап обычный двухрядный
                model           = 'Пикап'
                name            = 'pickup'
                type            = '2363'
                modification    = []
                image           = '/src/assets/images/models/pickup/pickup.jpg'
                break
            case '236021':      // Бортовой или фургон с однорядной кабиной
                model           = 'Профи'
                name            = 'profi'
                type            = '2360'
                modification    = []
                image           = '/src/assets/images/models/profi/profi.jpg'
                break
            case '236022':      // Бортовой или фургон с однорядной кабиной (непонятно отличие от 236021)
                model           = 'Профи'
                name            = 'profi'
                type            = '2360'
                modification    = []
                image           = '/src/assets/images/models/profi/profi.jpg'
                break
            case '236031':
                model           = 'Профи'
                name            = 'profi'
                type            = '2360'
                modification    = []
                image           = '/src/assets/images/models/profi/profi.jpg'
                break
            case '236323':
                model           = 'Профи'
                name            = 'profi'
                type            = '2363'
                modification    = []
                image           = '/src/assets/images/models/profi/236323.jpg'
                break
            case '236324':
                model           = 'Профи'
                name            = 'profi'
                type            = '2363'
                modification    = []
                image           = '/src/assets/images/models/profi/profi.jpg'
                break
            case '128801':
                model           = 'Профи'
                name            = 'profi'
                type            = '1288'
                modification    = []
                image           = '/src/assets/images/models/profi/profi.jpg'
                break
            case '128802':
                model           = 'Профи'
                name            = 'profi'
                type            = '1288'
                modification    = []
                image           = '/src/assets/images/models/profi/profi.jpg'
                break
            case '128811':
                model           = 'Профи'
                name            = 'profi'
                type            = '1288'
                modification    = []
                image           = '/src/assets/images/models/profi/profi.jpg'
                break
            case '292400':
                model           = 'Хантер'
                name            = 'hunter'
                type            = '2924'
                modification    = []
                image           = '/src/assets/images/models/hunter/hunter.jpg'
                break
        }

        return { model, name, type, modification, image }
    } 

    function getCarYear(index) {

        switch(index) {

            case '1': return '2001'
            case '2': return '2002'
            case '3': return '2003'
            case '4': return '2004'
            case '5': return '2005'
            case '6': return '2006'
            case '7': return '2007'
            case '8': return '2008'
            case '9': return '2009'
            case 'A': return '2010'
            case 'B': return '2011'
            case 'C': return '2012'
            case 'D': return '2013'
            case 'E': return '2014'
            case 'F': return '2015'
            case 'G': return '2016'
            case 'H': return '2017'
            case 'J': return '2018'
            case 'K': return '2019'
            case 'L': return '2020'
            case 'M': return '2021'
            case 'N': return '2022'
            case 'P': return '2023'
            case 'R': return '2024'
            case 'S': return '2025'
            case 'T': return '2026'
            case 'V': return '2027'
            case 'W': return '2028'
            case 'X': return '2029'
            case 'Y': return '2030'
            // case '1': return '2031'
            // case '2': return '2032'
            // case '3': return '2033'
            // case '4': return '2034'
            // case '5': return '2035'
            // case '6': return '2036'
            // case '7': return '2037'
            // case '8': return '2038'
            // case '9': return '2039'
            // case 'A': return '2040'
            default: return ''
        }
    }

    function getCarManufactorer(manufactorerCode) {

        if(manufactorerCode == 1)
            return 'ООО «УАЗ»'

        if(manufactorerCode == 2) 
            return 'ООО «АВТОДОМ»'
    }

    const { model, name, type, modification, image } = getCarModel(vin.slice(3,9))
    const code = vin.slice(3,9)
    const year = getCarYear(vin.slice(9,10))
    const manufactorer = getCarManufactorer(vin.slice(10,11))

    if(model)           vinInfo.model           = model
    if(name)            vinInfo.name            = name
    if(type)            vinInfo.type            = type
    if(modification)    vinInfo.modification    = modification
    if(image)           vinInfo.image           = image
    if(code)            vinInfo.code            = code
    if(year)            vinInfo.year            = year
    if(manufactorer)    vinInfo.manufactorer    = manufactorer

    return vinInfo
}
